import axios from "axios";
import { extractData, handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { CreateBusinessCustomerRequest, CreatePrivateCustomerRequest } from "models/register";
import { apiService } from "./api.service";


async function createBusinessCustomer(request: CreateBusinessCustomerRequest): Promise<{ customerId: number }> {
    return axios.post(apiService.getApiUrl() + '/customers/business',request)
        .then(handleResponse).then(extractData).catch(handleApiException);
}

async function createPrivateCustomer(request: CreatePrivateCustomerRequest): Promise<{ customerId: number }> {
    return axios.post(apiService.getApiUrl() + '/customers/private', request)
        .then(handleResponse).then(extractData).catch(handleApiException);
}

const RegisterService = {
    createBusinessCustomer,
    createPrivateCustomer
};

export default RegisterService;
